import React, { useState } from 'react';
import { ChevronDown, ChevronLeft } from 'lucide-react';
import './AdminSidebar.css';

function AdminSidebar({ activeTab, onTabChange, menuItems, roleColor, isMobileOpen, onMobileClose, isCollapsed, onToggleCollapse }) {
  const [expandedItems, setExpandedItems] = useState({});

  const toggleExpand = (itemId) => {
    setExpandedItems(prev => ({
      ...prev,
      [itemId]: !prev[itemId]
    }));
  };

  const renderMenuItems = (items, isNested = false) => {
    return items.map((item) => {
      // Skip rendering disabled items
      if (item.disabled) {
        return null;
      }

      const isExpanded = expandedItems[item.id];
      const hasChildren = item.children && item.children.length > 0;

      return (
        <div key={item.id} className={`nav-item-wrapper ${isNested ? 'nested' : ''}`}>
          <button
            className={`nav-item ${activeTab === item.id ? 'active' : ''}`}
            onClick={() => {
              if (hasChildren) {
                toggleExpand(item.id);
              } else {
                onTabChange(item.id);
                onMobileClose?.();
              }
            }}
            title={item.label}
            style={activeTab === item.id ? { borderLeftColor: roleColor } : {}}
          >
            <span className="nav-icon">
              {item.icon}
            </span>
            {!isCollapsed && <span className="nav-label">{item.label}</span>}
            {hasChildren && !isCollapsed && (
              <span className={`nav-expand-icon ${isExpanded ? 'expanded' : ''}`}>
                <ChevronDown size={16} />
              </span>
            )}
            {item.badge && !isCollapsed && (
              <span className="nav-badge">{item.badge}</span>
            )}
          </button>

          {hasChildren && isExpanded && !isCollapsed && (
            <div className="nav-children">
              {renderMenuItems(item.children, true)}
            </div>
          )}
        </div>
      );
    });
  };

  return (
    <>
      {/* Mobile Overlay */}
      {isMobileOpen && (
        <div className="sidebar-mobile-overlay" onClick={onMobileClose} />
      )}

      {/* Sidebar */}
      <aside className={`admin-sidebar ${isMobileOpen ? 'mobile-open' : ''} ${isCollapsed ? 'collapsed' : ''}`}>
        <div className="sidebar-header">
          <button
            className="collapse-btn"
            onClick={onToggleCollapse}
            title={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
            aria-label="Toggle sidebar"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="15 18 9 12 15 6" />
            </svg>
          </button>
        </div>

        <nav className="sidebar-nav">
          {renderMenuItems(menuItems)}
        </nav>
      </aside>
    </>
  );
}

export default AdminSidebar;
